import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import ApiManagement from '~/components/Admin/IntegrationPage/ApiManagement';
import { PageLayout } from '~/eds/src/modules/PageLayout/PageLayout';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const Page = () => {
  const intl = useIntl();
  const { params } = useRouting();
  const { clientId } = params;

  const nav = {
    actions: [
      {
        text: intl.formatMessage({
          id: 'IntegrationsDeprecated.navTitle',
          defaultMessage: 'Integrations',
          description: 'Navigation title for integrations page',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientIntegrations, {
          clientId: clientId as string,
        }),
      },
      {
        text: intl.formatMessage({
          id: 'ApiManagement.pageTitle',
          defaultMessage: 'API Management',
          description: 'API Management page title',
        }),
        pathname: generatePath(RoutePathType.AdminConsoleClientApiManagement, {
          clientId: clientId as string,
        }),
      },
    ],
  };

  return (
    <PageLayout
      title={intl.formatMessage({
        id: 'ApiManagement.pageTitle',
        defaultMessage: 'API Management',
        description: 'API Management page title',
      })}
      nav={nav}
    >
      <ApiManagement />
    </PageLayout>
  );
};

export default Page;
